import React, { createContext, useState } from 'react';

import { merge } from 'lodash';

import { MatxLayoutSettings } from 'components/Layout/settings';


const SettingsContext = createContext({
  settings: MatxLayoutSettings,
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  updateSettings: (_settings) => {},
});

export const SettingsProvider = ({ children }) => {
  const [currentSettings, setCurrentSettings] = useState(MatxLayoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
  };

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        updateSettings: handleUpdateSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
